import React, { useState } from 'react';
import { authenticateUser } from '../../utils/dataManager';
import { setCurrentUser } from '../../utils/auth';
import './LoginForm.css';

const LoginForm = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await authenticateUser(formData.username, formData.password);
      
      if (user) {
        setCurrentUser(user);
        onLogin(user);
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form-container">
      <div className="container">
        <div className="login-container">
          <div className="form-container">
            <div className="circle circle-one"></div>
            <div className="circle circle-two"></div>
          
            <h1>LOGIN</h1>
          
            <form onSubmit={handleSubmit}>
              {error && <div className="error-message">{error}</div>}
              
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="USERNAME"
                required
              />
              
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="PASSWORD"
                required
              />
              
              <button type="submit" disabled={loading}>
                {loading ? 'SIGNING IN...' : 'SUBMIT'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
